import {ImageSearchRequest, ImageSearchRequestCreation} from '@/domain/entities/ImageSearchRequest';
import {doCreate} from './apiRequests';

const PATH = 'image-search-requests';

const imageSearchRequestRepository = {
  create: (dto: ImageSearchRequestCreation): Promise<ImageSearchRequest> =>
    doCreate<ImageSearchRequestCreation, ImageSearchRequest>(PATH, dto),
};

export default imageSearchRequestRepository;